import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

export interface MessageDividerWrapperProps extends BoxProps {
  children: React.ReactNode;
}

export const MessageDividerWrapper = memo(function MessageDividerWrapper({
  className,
  children,
  ...props
}: MessageDividerWrapperProps) {
  return (
    <Box
      className={cls('MessageDivider', className)}
      display="flex"
      flexDirection="column"
      gap="5"
      alignItems="center"
      {...props}
    >
      {children}
    </Box>
  );
});
